// deviceConfigure.js
// external libs
import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import { Helmet } from 'react-helmet-async'
import { Link, useNavigate } from 'react-router-dom'

import AppStore from '../../stores/AppStore'
import Footer from '../partials/Footer'
import NavigationBar from '../partials/NavigationBar'
import withAppStore from '../../util/withAppStore'

import styles from '../../../css/devicePage.module.css'

function DistributorToolsPage (props) {
  const navigate = useNavigate()

  const goTo = React.useCallback((x) => navigate(x), [navigate])
  const goBack = React.useCallback(() => {
    goTo('/home')
  }, [goTo])

  React.useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const {
    auth: {
      logout,
    },
    intl: {
      formatMessage,
    },
    route: {
      path: page,
    },
    level,
  } = props

  const ADMIN = formatMessage({
    id: 'navigation.distributor',
    defaultMessage: 'Distributor Tools',
    description: 'Distributor Tools label',
  })

  const TRANSFER_DEVICES = formatMessage({
    id: 'navigation.transferDevices',
    defaultMessage: 'Transfer Devices',
    description: 'Transfer Devices label',
  })

  const {
    pages: {
      CustomerSettingsPage: title = ADMIN,
    },
  } = props

  const {
    id: customerID,
  } = AppStore.getCustomer()

  const navButton = (subPage, label) => (
    <div key={label} style={{ display: 'inline-block' }}>
      <Link
        to={subPage.match(/^[a-z]{1,25}/i) ? `/${customerID}/distributor/${subPage}` : subPage}
        className={styles.settingButtonCustomer}
      >
        <div className={`${styles.settingName} ${styles.settingNameCenter}`}>
          <h3>
            {label}
          </h3>
        </div>
      </Link>
    </div>
  )

  const navButtons = []

  if (level >= 20) {
    navButtons.push(navButton('transferDevices', TRANSFER_DEVICES))
  }

  return (
    <div>
      <Helmet><title>{title}</title></Helmet>
      <NavigationBar
        backFunc={goBack}
        page={page}
        name={ADMIN}
        logOut={() => logout(navigate)}
      />
      <div className={styles.pageWidth}>
        <div className={styles.pageContainer}>
          {navButtons}
        </div>
      </div>
      <Footer />
    </div>

  )
}

DistributorToolsPage.propTypes = {
  auth: PropTypes.object,
  intl: PropTypes.object,
  route: PropTypes.object,
  pages: PropTypes.object,
  level: PropTypes.number,
}

export default withAppStore(injectIntl(DistributorToolsPage))
